export default "__VITE_ASSET__DCClWfAj__"